import moment from 'moment'

const LISTING_STATUSES = ['FOR_SALE', 'FROZEN', 'RESERVED']

export function getSellerTicketUi(ticket) {
  if (ticket?.allowed_actions) {
    return {
      allowed_actions: ticket.allowed_actions,
      blocked_reason: ticket.blocked_reason || null,
      checkout_expires_at: ticket.checkout_expires_at || null,
    }
  }

  const allowed_actions = {
    view: true,
    edit: false,
    delete: false,
  }
  let blocked_reason = null

  switch (ticket?.status) {
    case 'FOR_SALE':
      allowed_actions.edit = true
      allowed_actions.delete = true
      break
    case 'FROZEN':
      blocked_reason = 'payment_in_progress'
      break
    case 'RESERVED':
      blocked_reason = 'reserved'
      break
    case 'SOLD':
      blocked_reason = 'sold'
      break
    case 'EXPIRED':
      blocked_reason = 'expired'
      break
    case 'DELETED':
      blocked_reason = 'deleted'
      break
    default:
      blocked_reason = 'unavailable'
      break
  }

  return { allowed_actions, blocked_reason, checkout_expires_at: null }
}

export function isEventActive(ticket) {
  return moment(ticket.last_sales_time).isAfter(moment.now())
}

export function isSaleDateActive(ticket) {
  return moment(`${ticket.last_sell_date}`).isSameOrAfter(moment.now(), 'day')
}

export function isListingStatus(ticket) {
  return LISTING_STATUSES.includes(ticket.status)
}

export function isActiveForSaleCount(ticket) {
  const { allowed_actions } = getSellerTicketUi(ticket)

  return (
    ticket.status === 'FOR_SALE' &&
    isSaleDateActive(ticket) &&
    isEventActive(ticket) &&
    allowed_actions.edit
  )
}

export function isInSellSection(ticket) {
  return (
    isListingStatus(ticket) &&
    isSaleDateActive(ticket) &&
    isEventActive(ticket)
  )
}

export function isSaleDateExpiredSection(ticket) {
  return (
    isListingStatus(ticket) &&
    !isSaleDateActive(ticket) &&
    isEventActive(ticket)
  )
}

export function isEventDateExpiredSection(ticket) {
  return ticket.status !== 'SOLD' && !isEventActive(ticket)
}
